<template>
    <div class="package-wrapper">
        <h2 class="page-subtitle">
            <router-link :to="{name: 'packageDetails', params: {id: id}}">
                {{ name }}
            </router-link>
        </h2>
        <div class="package-body">
            <div class="package-images">
                <a href="">
                    <img :src="images[0].src" alt=""
                         class="main-img">
                </a>
                <vue-picture-swipe :items="images" class="package-gallery"/>
            </div>
            <div class="description">
                <!--<p class="body-text">Desde <span class="highlight">${{ startingPrice }}</span></p>-->
                <br>
                <p class="body-text">{{ shortDescription }}</p>
                <ul>
                    <li v-for="text in includes">{{ text }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import VuePictureSwipe from 'vue-picture-swipe';

    export default {
        name: "PackageView",
        components: {
            VuePictureSwipe
        },
        props: {
            id: {
                type: Number,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            shortDescription: {
                type: String,
                required: true
            },
            startingPrice: {
                type: Number,
                required: true
            },
            images: {
                type: Array,
                required: true
            },
            includes: {
                type: Array,
                required: true
            }
        },
        data() {
            return {

            }
        }
    }
</script>

<style scoped>
    .package-wrapper {
        display: flex;
        flex-direction: column;
        padding: 15px 30px;
        margin-bottom: 50px;
        border-bottom: 1px solid #999;
    }

    .package-wrapper .page-subtitle a {
        color: #643229;
        text-decoration: none;
    }

    .package-wrapper .page-subtitle a:hover {
        text-decoration: underline;
    }

    .package-wrapper .package-body {
        display: flex;
    }

    .package-wrapper .package-images {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .package-wrapper .main-img {
        width: 100%;
    }

    .package-wrapper .description {
        padding: 0 20px;
    }

    .package-wrapper .description .highlight {
        color: #4d63bc;
        font-weight: 500;
        font-size: 2.5rem;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        .package-wrapper {
            padding: 0;
        }

        .package-wrapper .package-body {
            flex-direction: column;
        }

        .package-wrapper .description {
            padding: 0;
        }
    }
</style>